import React, { Dispatch, SetStateAction, useEffect, useState } from "react";

import api from "../../services/api";
import { verifyPermission } from "../../services/auth";
import { rucFormater } from "../../services/rucFormater";
import { cpfCnpjFormater } from "../../services/cpfCnpjFormater";
import { useWindowSize } from "../../hook/useWindowsSize";

import Brasil from "../../assets/image/brasil.webp";
import Paraguai from "../../assets/image/paraguai.webp";

import Spinner from "../../components/Spinner";
import UserCompanies from "../../components/UserCompanies";

import NfceForm from "../NfceForm";
import FocusForm from "../FocusForm";
import InvoiceSerieForm from "../InvoiceSerieForm";
import ModalAuditStore from "../ModalAuditStore";
import ModalFranchiseeInfo from "../ModalFranchiseeInfo";
import ModalFranchiseeAudit from "../ModalFranchiseeAudit";

import { User } from "../../models/entities/user";
import { CompanyUsers } from "../../models/entities/users";
import { FranchiseeInfo } from "../../models/entities/franchisee";
import { Company as CompanyModel } from "../../models/entities/company";

import moment from "moment";

import { Tooltip, message as messageAnt, notification } from "antd";

import {
  Table,
  MoreIcon,
  Dropdown,
  Menu,
  Modal,
  ModalCompanyUsers,
  Country,
  InformationCirclIcon,
  ActiveStatusIcon,
  InactiveStatusIcon,
  StatusBadge,
  FieldBadge,
  TitleTable,
} from "./styles";

const { SubMenu } = Menu;
interface IProps {
  setVisible: Dispatch<SetStateAction<boolean>>;
  company: CompanyModel | null;
  setCompany: Dispatch<SetStateAction<CompanyModel | null>>;
  setShouldSearch: Dispatch<SetStateAction<boolean>>;
  data: CompanyModel[];
  profileList: User[] | null;
  setVisibleCompanyInfoModal: Dispatch<SetStateAction<boolean>>;
}

export interface AuditStore {
  created_at: string;
  deleted_at: string | null;
  field: string;
  id: number;
  new_value: string;
  old_value: string;
  store_id: number;
  user_id: number;
  user_name: string;
}

const CompanyList: React.FC<IProps> = ({
  data,
  setCompany,
  setShouldSearch,
  company,
  setVisible,
  profileList,
  setVisibleCompanyInfoModal,
}) => {
  const [nfceVisible, setNfceVisible] = useState(false);
  const [focusVisible, setFocusVisible] = useState(false);
  const [nfSerieVisible, setNfSerieVisible] = useState(false)
  const [visibleUsers, setVisibleUsers] = useState(false);
  const [visibleAuditStore, setVisibleAuditStore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingAction, setLoadingAction] = useState(false);
  const [loadingAudit, setLoadingAudit] = useState(false);
  const [companyUsers, setCompanyUsers] = useState<CompanyUsers[]>([]);
  const [auditData, setAuditData] = useState<AuditStore[]>([]);
  const [companyId, setCompanyId] = useState<number | null>(null);

  const [auditFranchiseeData, setAudiFranchiseetData] = useState<any[]>([]);
  const [franchiseeInfo, setFranchiseeInfo] = useState<FranchiseeInfo[]>([]);
  const [visibleFranchiseeInfo, setVisibleFranchiseeInfo] = useState(false);
  const [visibleFranchiseeAudit, setVisibleFranchiseeAudit] = useState(false);
  const [loadingFranchiseeInfo, setLoadingFranchiseeInfo] = useState(false);

  const { width } = useWindowSize();

  const getScrollHeight = () => {
    if (width <= 1440) {
      return 550;
    }
    return 590;
  };

  useEffect(() => {
    const fetchAuditData = async () => {
      if (companyId) {
        setLoadingAudit(true);
        try {
          const {
            data: { content },
          } = await api.get(`/company-audit/${companyId}`);
          setAuditData(content);
        } catch (error: any) {
          messageAnt.error(error?.response?.data?.message);
        } finally {
          setLoadingAudit(false);
        }
      }
    };

    if (visibleAuditStore) fetchAuditData();
  }, [visibleAuditStore, companyId]);

  useEffect(() => {
    const fetchFranchiseeAuditData = async () => {
      if (companyId) {
        setLoadingAudit(true);
        try {
          const {
            data: { content },
          } = await api.get(`/company-franchisee-audit?store_id=${companyId}`);
          setAudiFranchiseetData(content);
        } catch (error: any) {
          messageAnt.error(error?.response?.data?.message);
        } finally {
          setLoadingAudit(false);
        }
      }
    };

    if (visibleFranchiseeAudit) fetchFranchiseeAuditData();
  }, [visibleFranchiseeAudit, companyId]);

  useEffect(() => {
    const fetchFranchiseeInfo = async () => {
      if (companyId) {
        setLoadingFranchiseeInfo(true);
        try {
          const {
            data: { content },
          } = await api.get(`/company-franchisee?company_id=${companyId}`);

          setFranchiseeInfo(content);
        } catch (error: any) {
          messageAnt.error(
            "Oops! Não foi possível buscar as informações dos franqueados!" +
              error
          );
        } finally {
          setLoadingFranchiseeInfo(false);
        }
      }
    };
    if (visibleFranchiseeInfo) fetchFranchiseeInfo();
  }, [visibleFranchiseeInfo, companyId]);

  const onDelete = (id: number) => {
    Modal.confirm({
      title: "Remover empresa",
      content: "Deseja continuar e remover este cadastro?",
      okText: "Sim",
      centered: true,
      okType: "primary",
      cancelText: "Não",
      async onOk() {
        try {
          await api.delete(`/company/${id}`);
          setShouldSearch(true);
        } catch (error: any) {
          messageAnt.error(error.response.data.message);
        }
      },
    });
  };

  const onDeleteFocus = (id) => {
    Modal.confirm({
      title: "Deseja realmente desvincular empresa na focus?",
      okText: "Sim",
      centered: true,
      okType: "primary",
      cancelText: "Não",
      width: 500,
      async onOk() {
        try {
          await api.delete(`/company/focus/${id}`);
          notification.success({
            message: `Empresa desvinculada da Focus com sucesso`,
            duration: 3,
          });
          setShouldSearch(true);
        } catch (e: any) {
          console.log(e.response);
          const _description = e?.response?.data?.message;
          notification.error({
            message: `Erro ao desvincular empresa na Focus`,
            description: _description || "",
            duration: 3,
          });
        }
      },
    });
  };

  const onHomologNfce = (company: CompanyModel) => {
    Modal.confirm({
      title: "Homologar emissão de nfce",
      content: "Deseja continuar e realizar a homologação?",
      okText: "Sim",
      centered: true,
      okType: "primary",
      cancelText: "Não",
      async onOk() {
        try {
          setLoadingAction(true);
          await api.put(`/company/enable-nfce/${company.id}`);
        } catch (e) {
          //@ts-ignore
          const _description = e?.response?.data?.message;

          notification.error({
            message: `Erro ao homologar emissão da nfce`,
            description: _description,
            duration: 3,
          });
        } finally {
          setLoadingAction(false);
        }
      },
    });
  };

  useEffect(() => {
    const fetchCompaniesUsers = async () => {
      setLoading(true);
      try {
        const {
          data: { content },
        } = await api.get(`/companyUser/${companyId}/company`);
        setCompanyUsers(content);
      } catch {
        messageAnt.error("Falha ao obter empresas do usuário");
      } finally {
        setLoading(false);
        setCompanyId(null);
      }
    };
    if (companyId) {
      fetchCompaniesUsers();
    }
  }, [companyId]);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      width: 80,
      key: "id",
    },
    {
      title: "País",
      dataIndex: "country",
      key: "country",
      width: 80,
      render: (text, record) => (
        <>
          {record.country === "brasil" ? (
            <Tooltip title="Brasil">
              <Country src={Brasil}></Country>
            </Tooltip>
          ) : (
            <Tooltip title="Paraguai">
              <Country src={Paraguai}></Country>
            </Tooltip>
          )}
        </>
      ),
    },
    {
      title: "Nome",
      dataIndex: "company_name",
      key: "company_name",
      width: 240,
      render: (text, record) => {
        if (text && text.trim() !== "") {
          return (
            <Tooltip title={text} placement="topLeft">
              <span className="company-name field-normal">{text}</span>
            </Tooltip>
          );
        } else {
          return (
            <Tooltip title="Nome da empresa não cadastrado" placement="topLeft">
              <FieldBadge fieldType="undefined">Indefinida</FieldBadge>
            </Tooltip>
          );
        }
      },
    },
    {
      title: "CNPJ / RUC",
      dataIndex: "cnpj",
      key: "cnpj",
      width: 220,
      render: (text, record) => {
        if (record?.country === "brasil") {
          if (record?.cnpj) {
            const formattedValue = cpfCnpjFormater(record?.cnpj);
            return (
              <Tooltip title={formattedValue} placement="topLeft">
                <span className="cnpj-ruc field-normal">{formattedValue}</span>
              </Tooltip>
            );
          } else {
            return (
              <Tooltip
                title="CNPJ não cadastrado - loja em processo de montagem"
                placement="topLeft"
              >
                <FieldBadge fieldType="setup">Loja em Montagem</FieldBadge>
              </Tooltip>
            );
          }
        } else if (record?.country === "paraguai") {
          if (record?.ruc) {
            const formattedValue = rucFormater(record?.ruc);
            return (
              <Tooltip title={formattedValue} placement="topLeft">
                <span className="cnpj-ruc field-normal">{formattedValue}</span>
              </Tooltip>
            );
          } else {
            return (
              <Tooltip
                title="RUC não cadastrado - loja em processo de montagem"
                placement="topLeft"
              >
                <FieldBadge fieldType="setup">Loja em Montagem</FieldBadge>
              </Tooltip>
            );
          }
        } else {
          return (
            <Tooltip
              title="País não definido - não é possível determinar tipo de documento"
              placement="topLeft"
            >
              <FieldBadge fieldType="undefined">Indefinida</FieldBadge>
            </Tooltip>
          );
        }
      },
    },
    {
      title: "Cidade",
      dataIndex: "city",
      key: "city",
      width: 180,
      render: (text) => {
        if (text && text.trim() !== "") {
          return (
            <Tooltip title={text} placement="topLeft">
              <span className="city-name field-normal">{text}</span>
            </Tooltip>
          );
        } else {
          return (
            <Tooltip title="Cidade não cadastrada" placement="topLeft">
              <FieldBadge fieldType="undefined">Indefinida</FieldBadge>
            </Tooltip>
          );
        }
      },
    },
    {
      title: (
        <div className="title-table">
          <Tooltip title="Status da empresa">
            <TitleTable>Status</TitleTable>
          </Tooltip>
        </div>
      ),
      dataIndex: "company_status",
      key: "company_status",
      width: 120,
      align: "center" as const,
      render: (text) => {
        const isActive = text === true;
        return (
          <Tooltip
            title={isActive ? "Empresa Ativa" : "Empresa Inativa"}
            placement="top"
          >
            {isActive ? (
              <ActiveStatusIcon twoToneColor="#05bd05" />
            ) : (
              <InactiveStatusIcon twoToneColor="#ff0000" />
            )}
          </Tooltip>
        );
      },
    },
    {
      title: "Cadastro NFC-e",
      dataIndex: "status",
      width: 220,
      key: "status",
      render: (_, record) => {
        const isBrazil = record?.country === "brasil";
        const isParaguay = record?.country === "paraguai";

        const hasCredentials =
          (isBrazil &&
            record?.token_focus_production &&
            record.token_focus_homologation) ||
          (isParaguay && record?.secret_key_py);

        const isExpired =
          isBrazil &&
          hasCredentials &&
          moment(record?.expiration_certificate) <= moment();

        const expirationDate = record?.expiration_certificate
          ? moment(record?.expiration_certificate).format("DD-MM-YYYY")
          : null;

        let statusText = "";
        let statusType: "success" | "error" | "warning" | "default" = "default";

        if (hasCredentials) {
          if (isExpired) {
            statusText = "Expirado";
            statusType = "error";
          } else {
            statusText = "Ativo";
            statusType = "success";
          }
        } else {
          statusText = "Ausente";
          statusType = "default";
        }

        return (
          <div className="certificate">
            <StatusBadge statusType={statusType} width="5rem">
              {statusText}
            </StatusBadge>
            {expirationDate && hasCredentials && (
              <Tooltip title={`Certificado válido até: ${expirationDate}`}>
                <span className="expiration_date">
                  Certificado válido até: {expirationDate}
                </span>
              </Tooltip>
            )}
          </div>
        );
      },
    },

    {
      dataIndex: "company_id_focus",
      key: "company_id_focus",
      align: "center" as const,
      width: 120,
      title: (
        <Tooltip title="Indica se a empresa está vinculada com a Focus">
          <div className="title-table">
            <TitleTable>Focus</TitleTable>
            <InformationCirclIcon />
          </div>
        </Tooltip>
      ),
      render: (_, record) => {
        const hasCompanyFocus = !!record?.company_id_focus;
        return (
          <StatusBadge statusType={hasCompanyFocus ? "success" : "error"}>
            {hasCompanyFocus ? "Sim" : "Não"}
          </StatusBadge>
        );
      },
    },

    {
      dataIndex: "web_hook_ciencia_nf_focus_id",
      key: "web_hook_ciencia_nf_focus_id",
      align: "center" as const,
      width: 140,
      title: (
        <Tooltip title="Auto Ciência: Para baixar os pdfs das notas fiscais da amadelli, é necessário ter a ciência automática habilitada na focus.">
          <div className="title-table">
            <TitleTable>Auto Ciência</TitleTable>
            <InformationCirclIcon />
          </div>
        </Tooltip>
      ),
      render: (_, record) => {
        const hasWebHook = !!record?.web_hook_ciencia_nf_focus_id;
        return (
          <StatusBadge statusType={hasWebHook ? "success" : "error"}>
            {hasWebHook ? "Sim" : "Não"}
          </StatusBadge>
        );
      },
    },

    {
      title: (
        <div className="title-table">
          <Tooltip title="Ações">
            <TitleTable>Ação</TitleTable>
          </Tooltip>
        </div>
      ),
      dataIndex: "name",
      key: "name",
      width: 100,
      align: "center" as const,
      render: (text, record) => (
        <>
          <Dropdown
            trigger={["click"]}
            overlay={
              <Menu key={record.id}>
                {verifyPermission("company.edit_contract_information") && (
                  <Menu.Item
                    onClick={() => {
                      setCompany(record);
                      setVisible(true);
                    }}
                    key="1"
                  >
                    <span>Editar Empresa</span>
                  </Menu.Item>
                )}
                <Menu.Item
                  onClick={() => {
                    setCompany(record);
                    setVisible(true);
                    setVisibleCompanyInfoModal(true);
                  }}
                  key="12"
                >
                  <span>Visualizar Dados da Empresa</span>
                </Menu.Item>

                {record.country === "brasil" &&
                  (verifyPermission("company.focus_register") ||
                    verifyPermission("company.focus_edit")) ? (
                    <Menu.Item
                      onClick={() => {
                        setFocusVisible(true);
                        setCompany(record);
                      }}
                      key="2"
                    >
                      <span>
                        {record?.company_id_focus
                          ? "Editar dados na Focus"
                          : "Vincular empresa na Focus"}
                      </span>
                    </Menu.Item>
                  ) : <></>}

                {record.country === "brasil" && !!record?.company_id_focus &&
                  (verifyPermission("company.nfce_serie_register")) ? (
                    <Menu.Item
                      onClick={() => {
                        setNfSerieVisible(true);
                        setCompany(record);
                      }}
                      key="9"
                    >
                      <span>
                        Editar série NFCe
                      </span>
                    </Menu.Item>
                  ) : <></>}

                {record.country === "brasil" &&
                  record?.company_id_focus &&
                  verifyPermission("company.focus_delete") ? (
                    <Menu.Item onClick={() => onDeleteFocus(record.id)} key="3">
                      <span style={{ color: "var(--red-600)" }}>
                        {" "}
                        Desvincular empresa na Focus
                      </span>
                    </Menu.Item>
                  ) : <></>}

                <Menu.Item
                  onClick={() => {
                    setVisibleUsers(true);
                    setCompanyId(record.id);
                  }}
                  key="4"
                >
                  <span>Lista de Usuários</span>
                </Menu.Item>
                {record.country === "brasil" &&
                  record.token_focus_homologation &&
                  verifyPermission("company.homolog_nfce") && (
                    <>
                      {loadingAction ? (
                        <Menu.Item key="5">
                          <Spinner />
                        </Menu.Item>
                      ) : (
                        <Menu.Item
                          onClick={() => onHomologNfce(record)}
                          key="5"
                        >
                          <span>Homologar Emissão de NFCe</span>
                        </Menu.Item>
                      )}
                    </>
                  )}

                <Menu.Item
                  onClick={() => {
                    setVisibleFranchiseeInfo(true);
                    setCompany(record);
                    setCompanyId(record.id);
                  }}
                  key="6"
                >
                  <span>Informações dos franqueados</span>
                </Menu.Item>
                <SubMenu key="sub1" title="Auditorias">
                  <Menu.Item
                    onClick={() => {
                      setVisibleAuditStore(true);
                      setCompany(record);
                      setCompanyId(record.id);
                    }}
                    key="7"
                  >
                    <span>Auditoria da loja</span>
                  </Menu.Item>
                  <Menu.Item
                    key="71"
                    onClick={() => {
                      setVisibleFranchiseeAudit(true);
                      setCompany(record);
                      setCompanyId(record.id);
                    }}
                  >
                    <span>Auditoria do franqueado</span>
                  </Menu.Item>
                </SubMenu>
                {verifyPermission("company.delete_contract_information") && (
                  <Menu.Item
                    onClick={() => onDelete(record.id)}
                    key="8"
                    style={{ borderTop: "1px solid var(--gray-100)" }}
                  >
                    <span style={{ color: "var(--red-600)" }}>
                      Remover Empresa
                    </span>
                  </Menu.Item>
                )}
              </Menu>
            }
            placement="bottomRight"
            arrow
          >
            <MoreIcon />
          </Dropdown>
        </>
      ),
    },
  ];

  return (
    <>
      <Table
        className="company-table"
        columns={columns}
        dataSource={data.map((entity) => ({ key: entity.id, ...entity }))}
        scroll={{ x: "max-content", y: getScrollHeight() }}
        scrollHeight={getScrollHeight()}
      />

      <NfceForm
        company={company}
        visible={nfceVisible}
        setVisible={setNfceVisible}
        setShouldSearch={setShouldSearch}
      />

      <FocusForm
        company={company}
        setCompany={setCompany}
        visible={focusVisible}
        setVisible={setFocusVisible}
        setShouldSearch={setShouldSearch}
      />

      <InvoiceSerieForm
        visible={nfSerieVisible}
        companyId={company?.id}
        invoiceSeries={company?.nfce_series_by_sales_channel}
        setShouldSearch={setShouldSearch}
        setVisible={setNfSerieVisible}
      />

      <ModalCompanyUsers
        title="Usuários vinculados"
        centered
        width={1000}
        visible={visibleUsers}
        footer={false}
        onCancel={() => {
          setVisibleUsers(false);
        }}
      >
        {loading ? (
          <Spinner />
        ) : (
          <UserCompanies
            data={companyUsers}
            company={company}
            profileList={profileList}
          />
        )}
      </ModalCompanyUsers>

      <ModalAuditStore
        visible={visibleAuditStore}
        setVisible={setVisibleAuditStore}
        company={company}
        loading={loadingAudit}
        setShouldSearch={setShouldSearch}
        auditData={auditData}
      />

      <ModalFranchiseeInfo
        visible={visibleFranchiseeInfo}
        setVisible={setVisibleFranchiseeInfo}
        company={company}
        loading={loadingFranchiseeInfo}
        franchiseeData={franchiseeInfo}
      />

      <ModalFranchiseeAudit
        visible={visibleFranchiseeAudit}
        setVisible={setVisibleFranchiseeAudit}
        company={company}
        loading={loadingAudit}
        auditFranchiseeData={auditFranchiseeData}
      />
    </>
  );
};

export default CompanyList;
